import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/icon-right-red.png'


const _withScopeId = n => (_pushScopeId("data-v-7f04d166"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pioneering-area ptb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "top-title",
    "data-aos": "fade-up",
    "data-aos-duration": "1200",
    "data-aos-delay": "100"
  }, "WHAT WE DO"),
  /*#__PURE__*/_createElementVNode("h2", {
    "data-aos": "fade-up",
    "data-aos-duration": "1200",
    "data-aos-delay": "200"
  }, " Pioneering Offline Advertising, Breathing Life Into Brands ")
], -1))
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = ["data-aos-delay"]
const _hoisted_6 = ["onMouseover"]
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icon-right-red"
}, null, -1))
const _hoisted_10 = { class: "col-lg-6 text-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Transforming your brand's online presence and generating meaningful results is our top priority at "),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "Adli."),
  /*#__PURE__*/_createTextVNode(" As a leading paid search ad agency, ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icon-right-red"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pioneerings, (pioneering) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-3 col-sm-6",
            key: pioneering.id,
            "data-aos": "fade-up",
            "data-aos-duration": "1200",
            "data-aos-delay": pioneering.dataDelay
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["pioneering-single-item transition-y", { active: _ctx.activePioneerings === pioneering.id }]),
              onMouseover: ($event: any) => (_ctx.setActivePioneerings(pioneering.id))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: pioneering.imageIcon,
                  alt: "rocket"
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("h3", null, _toDisplayString(pioneering.title), 1),
              _createElementVNode("p", null, _toDisplayString(pioneering.description), 1),
              _createVNode(_component_router_link, {
                to: "/career-details",
                class: "read-more"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" READ MORE "),
                  _hoisted_9
                ]),
                _: 1
              })
            ], 42, _hoisted_6)
          ], 8, _hoisted_5))
        }), 128)),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_router_link, {
            to: "career-details.html",
            class: "read-more"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" KNOW MORE ABOUT US "),
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}